import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ColumnGroup } from 'react-table';

import i18next from 'i18next';

import { BudgetProductType } from 'types/api/budgets.type';

export const useColumns = (product: BudgetProductType | undefined, date: string) => {
  const { t } = useTranslation();

  return useMemo(
    (): ColumnGroup[] => [
      {
        Header: 'Budgets',
        columns: [
          {
            Header: t('common.code')!,
            accessor: 'itemCode',
          },
          {
            Header: t('catalogue.fabric')!,
            accessor: 'mainFabricCode',
          },
          {
            Header: t('catalogue.material')!,
            accessor: 'mainFabricDesc',
          },
          {
            Header: t('statistics.marketing')!,
            accessor: 'styleCodeAndStyleDesc',
          },
          {
            Header: t('budget.prevSold')!,
            accessor: 'prevSold',
          },
          {
            Header: t('product.sold')!,
            accessor: 'currSold',
          },
          {
            Header: `Full ${date}`,
            accessor: 'currQuantity',
          },
          {
            Header: t('statistics.forecast')!,
            accessor: 'forecast',
            Cell: ({ row }) => (
              <span>{row.original.currSold + row.original.currQuantity}</span>
            ),
          },
        ],
      },
    ],
    [i18next.language, product, date]
  );
};
